import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class MainSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'main');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontFamilyField('font.family', []),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', []),
            this.fontColorComboField('font.color', []),

            this.backgroundColorField('background.color', []),
            this.borderColorField('border.color', []),

            this.sizeNumberField('gutter.width'),

            this.dropShadowField('shadow'),

            this.comboField('icon.pack', {
                'Font Awesome Solid': 'fontawesome:900',
                'Font Awesome Regular': 'fontawesome:400',
                'Font Awesome Light': 'fontawesome:300',
            }),            

        ];
    }

}
